export default __webpack_public_path__ + "static/media/image_unavailable.95aa68d8.png";